import {Injectable} from '@angular/core';
import {Params} from '@angular/router';
import {PartSearchService} from '@lib-services/part-search.service';

@Injectable({
    providedIn: 'root'
})
export class FilterPanelService {
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };

    constructor(private partSearchService: PartSearchService) {
    }

    createSearchParams(config: Params): Params {
        let searchParams: Params = {
            ...this.defaultFilterParams,
        };

        if (config) {
            Object.entries(config).forEach(([key, value]) => {
                if (value) {
                    let filterValue;
                    let params: string[];
                    switch (key) {
                    case 'addressDetails':
                        params = value.split(' ').map((el: string) => el.trim());
                        filterValue = [`$ilike:${params[0]}`].concat(this.partSearchService.createMultiStringParams(params.slice(1)));
                        break;
                    case 'contact.firstName':
                        params = value.split(' ').map((el: string) => el.trim());
                        filterValue = [`$ilike:${params[0]}`].concat(this.partSearchService.createMultiStringParams(params.slice(1)));
                        break;
                    case 'contact.phone':
                        filterValue = `$ilike:${value}`;
                        break;
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }
        return searchParams;
    }
}
